module.exports = __webpack_public_path__ + "img/4.4c6455c3.png";